import { Button } from '@/components/elements/forms/buttons';
import { CloseIcon } from '@/components/icons';
import { SMART_LINKS } from '@/constants/smartLinkConstants';
import { isServer, setCookie, showAndroidTopBanner } from '@/helpers';
import { _t } from '@/locale';
import * as moment from 'moment';

function AndroidTopBanner({ source }: { source: string }) {
  if (isServer) return null;

  const showBanner = showAndroidTopBanner();
  if (!showBanner) return null;

  const closeBanner = () => {
    setCookie('closedTopBanner', 'true', { path: '/', expires: moment().add(14, 'days').toDate() });
    window.location.reload();
  };

  const handleClick = () => {};

  // let downloadUrl = 'https://gm9v.adj.st/?adjust_t=5zk0f0m&adjust_campaign={$source}&adjust_adgroup=top-banner';
  let downloadUrl = SMART_LINKS.forceRedirectToStore(
    source === 'home'
      ? SMART_LINKS.HOME
      : source === 'search_results'
      ? SMART_LINKS.getSerpSmartLink(window.location.href) // ? SMART_LINKS.SERP
      : source === 'company_details'
      ? SMART_LINKS.getPlaceSmartLink(window.location.href) //SMART_LINKS.PLACE_TOP
      : SMART_LINKS.HOME,
  );

  return (
    <div className="bg-black-100 border-black-300 flex items-center border-y-[1px] py-2 pl-2 pr-4">
      <Button
        variant="link"
        className="!mr-2 !p-0"
        onClick={closeBanner}
        leftIcon={<CloseIcon className="text-black-900 h-4 w-4 p-[2px]" />}></Button>
      <img src="/images/top-banner-logo.svg" className="mr-2" alt="bokadirekt logo" width="30" height="30" />
      <div className="mr-2 flex flex-col">
        <span className="text-black-900 text-sm leading-[16px]">{_t('bookBeautyServicesEasy')}</span>
        <img src="/images/top-banner-stars-android.svg" className="mb-[3px]" alt="4,9 stars" width="59" height="9" />
        <span className="text-black-600 text-m">{_t('playStore')}</span>
      </div>
      <a
        href={downloadUrl}
        className="ml-auto rounded bg-[#00855e] px-3 py-1 text-sm uppercase text-white"
        onClick={handleClick}>
        {_t('download')}
      </a>
    </div>
  );
}

export default AndroidTopBanner;
